/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Search_PlaceholderInputs */

const cs_clients_search_placeholder = /** @type {(inputs: Clients_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno nebo příjmení…`)
};

const en_clients_search_placeholder = /** @type {(inputs: Clients_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name or surname…`)
};

/**
* | output |
* | --- |
* | "Name or surname…" |
*
* @param {Clients_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_search_placeholder = /** @type {((inputs?: Clients_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_search_placeholder(inputs)
	return cs_clients_search_placeholder(inputs)
});